import { decode } from './decode.js';

/**
 * Get the depth of a graph node selector
 *
 * if the selector is root children, the depth is 1
 */
export const getDepth = (selector: string) => {
  return decode(selector).byteLength / 2;
};
